import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Container, Col, Row, Alert } from 'reactstrap';
import { Redirect, Link } from 'react-router-dom';
import Axios from 'axios';
import { message } from 'antd';
import 'font-awesome/css/font-awesome.min.css';
import { RestURL } from '../../../config/properties';

// Import stylesheets and images
import './Home.scss';
import iconPortalDODLogoImg from '../../../images/iconportalDODlogo.png';
import foundryImg from '../../../images/foundry1_min.jpg';
// import iconLogoPng from '../../../images/icon-logo.png';
import xLogo from '../../../images/twitter.png';
import dlaLogo from '../../../images/dla.png';
import ntmaLogo from '../../../images/ntma.png';
import nffsLogo from '../../../images/NFFS.png';
import afcatLogo from '../../../images/afCat.png';
import castLogo from '../../../images/castIt.png';
import dodLogo from '../../../images/dod.png';
import msgs from '../../../config/messages';
import horizonLogo from '../../../images/horizon.jpg';
import fiaLogo from '../../../images/FIA_Logo-20250916-193022.png';

// Feature images and video
import soldiersImg from '../../../images/features/soldiers.png';
import statisticsImg from '../../../images/features/statistics.png';
import pouringImg from '../../../images/features/pouring-full-1.jpg';
import backgroundVideo from '../../../images/features/icon-webpage-video.mp4';
import navyjetsImg from '../../../images/navyjets.png';
import mroInventoryImg from '../../../images/mro_inventory.jpg';

// Components
import TopNav from '../../../components/TopNav';
import PolicyAgreementModal from '../../../components/PolicyAgreementModal';
import { getUserByEmail, agreeToPolicy } from '../../../components/Billsby/graphql';
import {
  accountAdminSubscription,
  toolingLocationListRoute,
  homeRoute, // eslint-disable-line no-unused-vars
  // aboutRoute,
  // contactRoute,
  // supportRoute,
  // registrationRoute,
  // loginRoute,
  salesOpportunitiesRoute,
  toolingRecordsRoute,
  supplierDatabaseRoute,
  newslettersRoute,
  growBusinessRoute
} from '../../../config/navigation/routes';
import { isFeatureEnabled } from '../../../config/featureFlags';

// Partner organization data
const partnerLogosConfig = {
  AFCAT: {
    name: 'AFCAT',
    url: 'https://amc.ati.org/cast-it/teaming/',
    logo: afcatLogo
  },
  NTMA: {
    name: 'NTMA - National Tooling and Machining Association',
    url: 'https://ntma.org',
    logo: ntmaLogo
  },
  NFFS: {
    name: 'NFFS',
    url: 'https://nffs.org',
    logo: nffsLogo
  },
  DLA: {
    name: 'Defense Logistics Agency',
    url: 'https://www.dla.mil/',
    logo: dlaLogo
  },
  CAST: {
    name: 'CAST - Cast Iron and Steel',
    url: 'https://amc.ati.org/cast-it/',
    logo: castLogo
  },
  DOD: {
    name: 'Defense Department',
    url: 'https://www.defense.gov/',
    logo: dodLogo
  },
  HORIZON: {
    name: 'Horizon',
    url: 'https://hil.us/',
    logo: horizonLogo
  },
  FIA: {
    name: 'Forging Industry Association',
    url: 'https://www.forging.org/',
    logo: fiaLogo
  }
};

class Home extends React.Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    originalOrgId: PropTypes.string,
    orgInfo: PropTypes.object,
    newMessage: PropTypes.bool.isRequired,
    newMessageCount: PropTypes.number.isRequired,
    canSeeMessageCenter: PropTypes.bool,
    alertMessages: PropTypes.instanceOf(Array),
    subscriptionLevel: PropTypes.string,
    organizationId: PropTypes.string,
  };

  static defaultProps = {
    originalOrgId: null,
    orgInfo: null,
    canSeeMessageCenter: false,
    alertMessages: [],
    subscriptionLevel: '',
    organizationId: null,
  };

  constructor() {
    super();
    this.state = {
      currentSlide: 0,
      bannerHtml: '',
      showPolicyModal: false,
      checkingPolicy: false,
      isRejectingPolicy: false,
    };
    this.sliderRef = React.createRef();
    this.autoPlayRef = React.createRef();
    this.isRejectingPolicyRef = React.createRef();
    this.isRejectingPolicyRef.current = false;

    // Add more partners to ensure enough logos for the slider
    this.partners = [
      { id: 1, name: partnerLogosConfig.AFCAT.name, url: partnerLogosConfig.AFCAT.url, logo: partnerLogosConfig.AFCAT.logo },
      { id: 2, name: partnerLogosConfig.NFFS.name, url: partnerLogosConfig.NFFS.url, logo: partnerLogosConfig.NFFS.logo },
      { id: 3, name: partnerLogosConfig.DLA.name, url: partnerLogosConfig.DLA.url, logo: partnerLogosConfig.DLA.logo },
      { id: 4, name: partnerLogosConfig.NTMA.name, url: partnerLogosConfig.NTMA.url, logo: partnerLogosConfig.NTMA.logo },
      { id: 5, name: partnerLogosConfig.CAST.name, url: partnerLogosConfig.CAST.url, logo: partnerLogosConfig.CAST.logo },
      { id: 6, name: partnerLogosConfig.DOD.name, url: partnerLogosConfig.DOD.url, logo: partnerLogosConfig.DOD.logo },
      { id: 7, name: partnerLogosConfig.HORIZON.name, url: partnerLogosConfig.HORIZON.url, logo: partnerLogosConfig.HORIZON.logo },
      { id: 8, name: partnerLogosConfig.FIA.name, url: partnerLogosConfig.FIA.url, logo: partnerLogosConfig.FIA.logo },
    ];
  }

  componentWillMount() {
    this.mounted = true;
  }

  async componentDidMount() {
    try {
      // Fetch persistent banner
      const res = await Axios.get(`${RestURL}rest/api/banner`);
      if (res.data && res.data.trim().length > 0) {
        this.setState({ bannerHtml: res.data });
      }
      // Set up auto-play for slider with a delay to avoid initial performance impact
      setTimeout(() => {
        if (this.mounted) {
          this.autoPlayRef.current = setInterval(() => {
            this.nextSlide();
          }, 3000);
        }
      }, 1000);
      
      // Check policy agreement for authenticated users (only if feature is enabled)
      if (isFeatureEnabled('ENABLE_POLICY_AGREEMENT')) {
        this.checkPolicyAgreement();
      }
    } catch (error) {
      console.error("Error in componentDidMount:", error);
    }
  }

  checkPolicyAgreement = async () => {
    const { auth } = this.props;
    
    // Only check if feature is enabled
    if (!isFeatureEnabled('ENABLE_POLICY_AGREEMENT')) {
      return;
    }
    
    // Only check for authenticated users
    if (!auth || !auth.email || this.state.checkingPolicy) {
      return;
    }

    this.setState({ checkingPolicy: true });

    try {
      const userInformation = await getUserByEmail(auth.email);
      if (userInformation && userInformation.getUserByEmailOrganization) {
        const policyAgreementDate = userInformation.getUserByEmailOrganization.policyAgreementDate;
        
        // Show modal if user hasn't agreed to policy yet
        if (!policyAgreementDate || policyAgreementDate === null) {
          this.setState({ showPolicyModal: true });
        }
      }
    } catch (error) {
      console.error('Error checking policy agreement:', error);
      // On error, show modal to be safe
      this.setState({ showPolicyModal: true });
    } finally {
      this.setState({ checkingPolicy: false });
    }
  };

  handlePolicyApprove = async () => {
    const { auth } = this.props;
    
    try {
      if (!auth || !auth.id) {
        console.error('Cannot agree to policy: user not authenticated');
        return;
      }

      // Save policy agreement to DynamoDB
      await agreeToPolicy(auth.id);
      
      // Close the modal - it won't show again since we saved the agreement
      // After closing modal, the component will re-render and the redirect logic
      // will now allow the Billsby redirect (since showPolicyModal is false)
      this.setState({ showPolicyModal: false });
      
      // Refresh the page to ensure all user data (including subscription level) is updated
      // This ensures the user can access all features after accepting the policy
      window.location.reload();
    } catch (error) {
      console.error('Error agreeing to policy:', error);
      // Keep modal open on error so user can try again
    }
  };

  handlePolicyDisapprove = () => {
    const { logout } = this.props;
    
    // Set ref immediately (synchronous) to prevent redirects
    this.isRejectingPolicyRef.current = true;
    
    // Set state flag to prevent redirects during logout process
    this.setState({ 
      isRejectingPolicy: true,
      showPolicyModal: false 
    });
    
    // Show message explaining why they're being logged out
    message.warning('You must accept the ICON Use Policies to access the system. You will be logged out.', 3);
    
    // Immediately sign the user out - don't wait, logout will handle navigation
    logout();
  };

  componentDidUpdate(prevProps, prevState) {
    // Only update slider position when currentSlide actually changes
    if (this.sliderRef.current && prevState.currentSlide !== this.state.currentSlide) {
      const slideWidth = 100 / this.partners.length;
      this.sliderRef.current.style.transform = `translateX(-${this.state.currentSlide * slideWidth}%)`;
    }
    
    // Check policy agreement when auth becomes available (only if feature is enabled)
    if (isFeatureEnabled('ENABLE_POLICY_AGREEMENT') && prevProps.auth !== this.props.auth && this.props.auth && this.props.auth.email && !this.state.checkingPolicy && !this.state.showPolicyModal) {
      this.checkPolicyAgreement();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.autoPlayRef.current) {
      clearInterval(this.autoPlayRef.current);
      this.autoPlayRef.current = null;
    }
  }

  // Function to handle next slide
  nextSlide = () => {
    const totalSlides = this.partners.length;
    this.setState(prevState => {
      // When we reach the end of original slides, quickly reset to first slide
      if (prevState.currentSlide >= totalSlides - 1) {
        return { currentSlide: 0 };
      }
      return { currentSlide: prevState.currentSlide + 1 };
    });
  };

  // Function to handle previous slide
  prevSlide = () => {
    const totalSlides = this.partners.length;
    this.setState(prevState => {
      // When we go past the first slide, quickly jump to the last slide
      if (prevState.currentSlide <= 0) {
        return { currentSlide: totalSlides - 1 };
      }
      return { currentSlide: prevState.currentSlide - 1 };
    });
  };

  // Function to handle dot click
  goToSlide = (index) => {
    this.setState({ currentSlide: index });
  };

  render() {
    const {
      login,
      logout,
      auth,
      originalOrgId,
      orgInfo,
      newMessage,
      newMessageCount,
      canSeeMessageCenter,
      alertMessages,
      subscriptionLevel,
      organizationId,
    } = this.props;

    const { currentSlide, bannerHtml, showPolicyModal } = this.state;
    const totalSlides = this.partners.length;

    // VERY simplified redirect logic - only redirect if we're absolutely sure
    // Don't attempt redirect during initial render or partial auth state
    // IMPORTANT: Block ALL redirects if policy modal is showing or being checked
    // ALL users (GOVERNMENT, COMMON_ADMIN, etc.) must accept policy before being redirected
    // Also block redirects if user is rejecting policy (will be logged out)
    // Use ref for synchronous check since state updates are async
    if (
      auth && 
      auth.jwtToken && 
      auth.role && 
      typeof auth.role === 'string' && 
      organizationId !== null &&
      !this.state.showPolicyModal &&
      !this.state.checkingPolicy &&
      !this.state.isRejectingPolicy &&
      !this.isRejectingPolicyRef.current
    ) {
      const role = auth.role.toUpperCase();
      if (role.includes('GOVERNMENT')) {
        return <Redirect to={toolingLocationListRoute} />;
      } else if (role.includes('COMMON_ADMIN') && isFeatureEnabled('ENABLE_BILLSBY') && !subscriptionLevel) {
        return <Redirect to={accountAdminSubscription} />;
      }
    }

    return (
      <div className="nf-landing">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Welcome</title>
        </Helmet>
        {/* Header Section */}
        <TopNav
          login={login}
          logout={logout}
          auth={auth}
          originalOrgId={originalOrgId}
          orgInfo={orgInfo}
          newMessage={newMessage}
          newMessageCount={newMessageCount}
          canSeeMessageCenter={canSeeMessageCenter}
          isHomePage
        />
        {/* Hero Section */}
        <section className="nf-landing__hero">
          <div className="nf-landing__video-background">
            <video autoPlay loop muted playsInline className="nf-landing__background-video">
              <source src={backgroundVideo} type="video/mp4" />
              <track kind="captions" src="" label="English captions" />
              {/* Fallback to static image if video doesn't load */}
              <div className="nf-landing__hero-background" style={{ backgroundImage: `url(${foundryImg})` }} />
            </video>
            {/* Persistent Banner - positioned as an overlay on the video */}
            {bannerHtml && (
              <div className="nf-landing__persistent-banner">
                <span dangerouslySetInnerHTML={{ __html: bannerHtml }} />
              </div>
            )}
          </div>
          <div className="nf-landing__overlay">
            <Container className="nf-landing__content">
              {alertMessages && alertMessages.length > 0 && (
                <Row className="mt-5 pt-3">
                  <Col>
                    {alertMessages.map((am, index) => (
                      <Alert key={am.id || `alert-${index}`} color={am.alertType}>
                        {am.alertMessage}
                      </Alert>
                    ))}
                  </Col>
                </Row>
              )}

              <Row className="justify-content-center">
                <Col xs={12} className="text-center">
                  <div className="nf-landing__hero-content">
                    <h1 className="nf-landing__title">Connecting Industry and the U.S. Military</h1>
                    <p className="nf-landing__subtitle">
                      An advanced platform providing robust E-sourcing solutions that deliver defense industry
                      <span className="nf-landing__highlight"> CASTING</span>,
                      <span className="nf-landing__highlight"> FORGING</span> and
                      <span className="nf-landing__highlight"> MACHINING</span> business opportunities directly to qualified suppliers
                    </p>
                    <div className="nf-landing__cta-container">
                      <a href="#features" className="nf-landing__scroll-btn">
                        <span>Explore Services</span>
                        <i className="fa fa-angle-down" />
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="justify-content-center mt-3 pt-2" id="features">
                <Col xs={12} className="text-center mb-3">
                  <h2 className="nf-landing__section-heading">Our Advanced Capabilities</h2>
                  <p className="nf-landing__section-description">ICON provides essential services to strengthen the defense industrial base through cutting-edge technology solutions</p>
                </Col>
              </Row>

              <div className="nf-landing__features-container">
                <Row className="justify-content-center">
                  {isFeatureEnabled('ENABLE_SALES_OPPORTUNITIES') && (
                    <Col xs={12} md={6} lg={4} className="mb-4">
                      <Link to={salesOpportunitiesRoute} className="nf-landing__feature-link">
                        <div className="nf-landing__feature-card">
                          <div className="nf-landing__feature-img-container">
                            <img src={soldiersImg} alt="Sales Opportunities" className="nf-landing__feature-img-full" />
                            <div className="nf-landing__feature-overlay" />
                          </div>
                          <div className="nf-landing__feature-content">
                            <h3 className="nf-landing__feature-title">SALES OPPORTUNITIES</h3>
                            <div className="nf-landing__feature-divider" />
                            <p className="nf-landing__feature-desc">Daily sales opportunities matched to your plant capabilities or existing tooling</p>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  )}

                  <Col xs={12} md={6} lg={4} className="mb-4">
                    <Link to={toolingRecordsRoute} className="nf-landing__feature-link">
                      <div className="nf-landing__feature-card">
                        <div className="nf-landing__feature-img-container">
                          <img src={statisticsImg} alt="Tooling Records" className="nf-landing__feature-img-full" />
                          <div className="nf-landing__feature-overlay" />
                        </div>
                        <div className="nf-landing__feature-content">
                          <h3 className="nf-landing__feature-title">TOOLING RECORDS</h3>
                          <div className="nf-landing__feature-divider" />
                          <p className="nf-landing__feature-desc">Access to foundry, forging, and machining tooling locations and availability</p>
                        </div>
                      </div>
                    </Link>
                  </Col>

                  {isFeatureEnabled('ENABLE_SUPPLIER_DATABASE') && (
                    <Col xs={12} md={6} lg={4} className="mb-4">
                      <Link to={supplierDatabaseRoute} className="nf-landing__feature-link">
                        <div className="nf-landing__feature-card">
                          <div className="nf-landing__feature-img-container">
                            <img src={pouringImg} alt="Supplier Database" className="nf-landing__feature-img-full" />
                            <div className="nf-landing__feature-overlay" />
                          </div>
                          <div className="nf-landing__feature-content">
                            <h3 className="nf-landing__feature-title">SUPPLIER DATABASE</h3>
                            <div className="nf-landing__feature-divider" />
                            <p className="nf-landing__feature-desc">Find a foundry, forge, or machine shop with specific process capabilities</p>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  )}

                  <Col xs={12} md={6} lg={4} className="mb-4">
                    <Link to={newslettersRoute} className="nf-landing__feature-link">
                      <div className="nf-landing__feature-card">
                        <div className="nf-landing__feature-img-container">
                          <img src={navyjetsImg} alt="Newsletters" className="nf-landing__feature-img-full" />
                          <div className="nf-landing__feature-overlay" />
                        </div>
                        <div className="nf-landing__feature-content">
                          <h3 className="nf-landing__feature-title">NEWSLETTERS</h3>
                          <div className="nf-landing__feature-divider" />
                          <p className="nf-landing__feature-desc">Latest industry and system news from the ICON community</p>
                        </div>
                      </div>
                    </Link>
                  </Col>

                  {isFeatureEnabled('ENABLE_GROW_BUSINESS') && (
                    <Col xs={12} md={6} lg={4} className="mb-4">
                      <Link to={growBusinessRoute} className="nf-landing__feature-link">
                        <div className="nf-landing__feature-card">
                          <div className="nf-landing__feature-img-container">
                            <img src={mroInventoryImg} alt="Grow Your Business" className="nf-landing__feature-img-full" />
                            <div className="nf-landing__feature-overlay" />
                          </div>
                          <div className="nf-landing__feature-content">
                            <h3 className="nf-landing__feature-title">GROW YOUR BUSINESS</h3>
                            <div className="nf-landing__feature-divider" />
                            <p className="nf-landing__feature-desc">Tailored bid matching with customizable settings for daily opportunity notifications</p>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  )}
                </Row>
              </div>
            </Container>
          </div>
        </section>

        {/* Third Section - About ICON Portal */}
        <section className="nf-landing__section nf-landing__section--split nf-landing__section--gray">
          <Row>
            <Col md={12} lg={7}>
              <div
                className="nf-landing__section-img"
                style={{ backgroundImage: `url(${iconPortalDODLogoImg})` }}
              />
            </Col>
            <Col md={12} lg={5}>
              <div className="nf-landing__section-content">
                <div className="nf-landing__info-block">
                  <div className="nf-landing__info-icon">
                    <i className="icon-laptop" />
                    <i className="icon-desktop" />
                    <i className="icon-tablet" />
                  </div>
                  <div className="nf-landing__info-content">
                    <h5>{msgs.HomePage.info4.header}</h5>
                    <p>{msgs.HomePage.info4.text}</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </section>

        {/* Partners Section */}
        <section className="nf-landing__partners-section">
          <Container>
            <Row className="justify-content-center">
              <Col xs={12} className="text-center">
                <h2 className="nf-landing__section-heading nf-landing__partners-heading">ICON PARTNERS</h2>
                <p className="nf-landing__section-description">Collaborating with industry leaders to strengthen America&apos;s defense manufacturing capabilities</p>
              </Col>
            </Row>

            <div className="nf-landing__partners-slider">
              <div className="nf-landing__slider-container">
                <div className="nf-landing__slider-track" ref={this.sliderRef}>
                  {/* First set of partner logos */}
                  {this.partners.map((partner) => (
                    <div key={`partner-${partner.id}`} className="nf-landing__partner-slide">
                      <a
                        href={partner.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nf-landing__partner-logo-link"
                      >
                        {partner.logo ? (
                          <img
                            src={partner.logo}
                            alt={partner.name}
                            className="nf-landing__partner-logo"
                          />
                        ) : (
                          <div className="nf-landing__partner-logo-placeholder">
                            {partner.name}
                          </div>
                        )}
                      </a>
                    </div>
                  ))}

                  {/* Duplicate logos to create seamless loop effect */}
                  {this.partners.map((partner) => (
                    <div key={`duplicate-${partner.id}`} className="nf-landing__partner-slide">
                      <a
                        href={partner.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nf-landing__partner-logo-link"
                      >
                        {partner.logo ? (
                          <img
                            src={partner.logo}
                            alt={partner.name}
                            className="nf-landing__partner-logo"
                          />
                        ) : (
                          <div className="nf-landing__partner-logo-placeholder">
                            {partner.name}
                          </div>
                        )}
                      </a>
                    </div>
                  ))}
                </div>
              </div>

              {/* Navigation Arrows */}
              <button
                className="nf-landing__slider-arrow nf-landing__slider-arrow--prev"
                onClick={this.prevSlide}
                aria-label="Previous slide"
              >
                <i className="fa fa-chevron-left" />
              </button>
              <button
                className="nf-landing__slider-arrow nf-landing__slider-arrow--next"
                onClick={this.nextSlide}
                aria-label="Next slide"
              >
                <i className="fa fa-chevron-right" />
              </button>

              {/* Slider Indicators */}
              <div className="nf-landing__slider-indicators">
                {[...Array(totalSlides)].map((_, index) => (
                  <button
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    className={`nf-landing__slider-dot ${currentSlide === index ? 'nf-landing__slider-dot--active' : ''}`}
                    onClick={() => this.goToSlide(index)}
                    aria-label={`Go to slide ${index + 1}`}
                    type="button"
                  />
                ))}
              </div>
            </div>

            {/* Social Media Links */}
            <div className="nf-landing__social-links">
              <a href="https://www.facebook.com/NFFSICON" target="_blank" rel="noopener noreferrer" className="nf-landing__social-link">
                <i className="fa fa-facebook" aria-hidden="true" /> Facebook
              </a>
              <a href="https://x.com/INsrayburn" target="_blank" rel="noopener noreferrer" className="nf-landing__social-link">
                <img src={xLogo} alt="X.com" className="nf-landing__social-icon-img" /> X.com
              </a>
              <a href="https://www.youtube.com/channel/UCin4Qs1EM__EkkGLWtRJQYw" target="_blank" rel="noopener noreferrer" className="nf-landing__social-link">
                <i className="fa fa-youtube-play" aria-hidden="true" /> YouTube
              </a>
            </div>
          </Container>
        </section>

        {/* Policy Agreement Modal - Center */}
        {isFeatureEnabled('ENABLE_POLICY_AGREEMENT') && showPolicyModal && (
          <PolicyAgreementModal
            isOpen={showPolicyModal}
            onApprove={this.handlePolicyApprove}
            onDisapprove={this.handlePolicyDisapprove}
            position="center"
          />
        )}
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/static/Home/Home.jsx